import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaTasks, FaCheckCircle, FaHourglassHalf, FaClock, FaInbox } from 'react-icons/fa';
import { taskService } from '../../../services/task.service';
import { useAuth } from '../../../context/AuthContext';
import './Summary.css';

const ProductivitySummary = () => {
  const [taskStats, setTaskStats] = useState({
    total: 0,
    completed: 0,
    inProgress: 0,
    inReview: 0,
    backlog: 0
  });
  const { user } = useAuth();

  useEffect(() => {
    let unsubscribe;

    if (user) {
      unsubscribe = taskService.subscribeToTasks(user.uid, (tasks) => {
        const stats = {
          total: 0,
          completed: 0,
          inProgress: 0,
          inReview: 0,
          backlog: 0
        };

        Object.values(tasks).flat().forEach(task => {
          stats.total++;
          switch (task.status) {
            case 'completed':
              stats.completed++;
              break;
            case 'inProgress':
              stats.inProgress++;
              break;
            case 'inReview':
              stats.inReview++;
              break;
            case 'backlog':
              stats.backlog++;
              break;
            default:
              break;
          }
        });

        setTaskStats(stats);
      });
    }

    return () => unsubscribe && unsubscribe();
  }, [user]);

  return (
    <div className="summary-card">
      <div className="summary-header">
        <h2>Productivity</h2>
        <FaTasks className="summary-icon" />
      </div>

      <div className="summary-stats">
        <div className="stat-item">
          <div className="stat-icon">
            <FaCheckCircle />
          </div>
          <div className="stat-info">
            <span className="stat-value">{taskStats.completed}</span>
            <span className="stat-label">Completed</span>
          </div>
        </div>

        <div className="stat-item">
          <div className="stat-icon">
            <FaHourglassHalf />
          </div>
          <div className="stat-info">
            <span className="stat-value">{taskStats.inProgress}</span>
            <span className="stat-label">In Progress</span>
          </div>
        </div>

        <div className="stat-item">
          <div className="stat-icon">
            <FaClock />
          </div>
          <div className="stat-info">
            <span className="stat-value">{taskStats.inReview}</span>
            <span className="stat-label">In Review</span>
          </div>
        </div>

        <div className="stat-item">
          <div className="stat-icon">
            <FaInbox />
          </div>
          <div className="stat-info">
            <span className="stat-value">{taskStats.backlog}</span>
            <span className="stat-label">Backlog</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductivitySummary; 